/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertReservationExtraTextRequest
 */
export interface UpsertReservationExtraTextRequest {
    /**
     * 
     * @type {string}
     * @memberof UpsertReservationExtraTextRequest
     */
    text: string;
}

/**
 * Check if a given object implements the UpsertReservationExtraTextRequest interface.
 */
export function instanceOfUpsertReservationExtraTextRequest(value: object): value is UpsertReservationExtraTextRequest {
    if (!('text' in value) || value['text'] === undefined) return false;
    return true;
}

export function UpsertReservationExtraTextRequestFromJSON(json: any): UpsertReservationExtraTextRequest {
    return UpsertReservationExtraTextRequestFromJSONTyped(json, false);
}

export function UpsertReservationExtraTextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertReservationExtraTextRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
    };
}

export function UpsertReservationExtraTextRequestToJSON(json: any): UpsertReservationExtraTextRequest {
    return UpsertReservationExtraTextRequestToJSONTyped(json, false);
}

export function UpsertReservationExtraTextRequestToJSONTyped(value?: UpsertReservationExtraTextRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
    };
}

